<div [ngClass]="customClass" [ngStyle]="customStyle">
    <mat-form-field class="form-group dark-input multiline-select">
        <mat-label>Selected channel(s)</mat-label>
        <mat-select
            multiple
            [formControl]="control"
            [disabled]="disabled || previewMode"
            (selectionChange)="onSelectionChange($event)"
            panelClass="select-panel-down"
            disableOptionCentering
        >

            <mat-select-trigger>
                {{ control.value?.length || 0 }}
                {{ (control.value?.length === 1) ? 'channel' : 'channels' }} selected
            </mat-select-trigger>

            <mat-option
                *ngIf="!disabled && !previewMode"
                class="select-all"
                [class.mat-selected]="areAllSelected()"
                (click)="onToggleAll()"
                value="All"
            >
                <mat-checkbox [checked]="areAllSelected()" (click)="$event.preventDefault()">
                    Select All
                </mat-checkbox>
            </mat-option>

            <mat-option
                *ngFor="let channel of channels"
                [value]="channel"
                [disabled]="isChannelDisabled(channel)"
            >
                {{ channel.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <div style="display: flex; flex-wrap: wrap; gap: 10px; margin: 10px 0">
        <div *ngFor="let channel of scheduleChannels; index as i" class="channel-chip">
            {{ channel.name }}
            <a
                *ngIf="!disabled && !previewMode"
                class="remove-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary additional-remove-btn-style"
                (click)="onRemove(i)"
            >
                <h6 class="text-white">x</h6>
            </a>
        </div>
    </div>
</div>